import styled from 'styled-components'

export const Container = styled.div`
  /* position: absolute;
  top: -125px;
  right: 80px; */
  display: flex;
  flex-direction: row;
  /* @media (max-width: 1000px) {
    position: relative;
    align-items: center;
    justify-content: center;
    top: 0px;
    right: 0px;
    margin-bottom: 50px;
  } */
  @media (max-width: 650px) {
    width: 90%;
    left: 5%;
    right: 5%;
  }
`
